import "./Time.scss";

export default function Time() {
  return (
    <section className="sales-layout__page time">
      <h1>Zeit</h1>
      <p>Hier werden zukünftig die Zeitfunktionen verwaltet.</p>
    </section>
  );
}
